import { styled } from '@material-ui/core';
import { DatePicker } from '@ds/react-components';

export const NoticePeriodWrapper = styled('div')({});

export const NoticePeriodStartDatePicker = styled(DatePicker)({
  width: '166px',
});
